import type { Params } from '../types';

export function extractQueryParamsFromString(queryParamsString: string): Params {
  const urlSearchParams: URLSearchParams = new URLSearchParams(queryParamsString);
  const queryParams: Params = {};
  for (const [key, value] of urlSearchParams.entries()) {
    queryParams[key] = value;
    if (value === 'true') {
      queryParams[key] = true;
    }
    if (queryParams[key] === 'false') {
      queryParams[key] = false;
    }
    if (!isNaN(Number(value))) {
      queryParams[key] = Number(value);
    }
  }
  return queryParams;
}
